import React, { useState } from "react";
import { walletbills } from "../placeholder";

export default function (props) {
  const [input, setInput] = useState(props.value || "");

  return (
    <div className="approved block-view">
      <form className="approved-search" onSubmit={(e) => e.preventDefault()}>
        <input
          type="text"
          className="approved-search__input"
          placeholder="Enter wallet address"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
        <button type="submit" className="approved-search__btn">
          <img src="/assets/images/page-icons/search.svg" alt="search" />
        </button>
      </form>
      <ul className="approved-list custom-scrollbar">
        {walletbills.map((item, id) => (
          <li className="approved-item" key={id}>
            <span className="approved-item__wallet">{item.bill}</span>
            <span className="approved-item__value">{item.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
